import React from "react";
import "./Hero.css";
import heroConfig from "../../../config/home.json"
// import backgroundImage from "../../../assets/pics/team-logo.png"

const HeroSection = () => {
  const backgroundImage = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/New-Gladiators-Logo.jpg"
  return (
    <div
      className="hero-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">{heroConfig.hero.title}</h1>
        <p className="hero-subtitle">{heroConfig.hero.subTitle}</p>
      </div>
    </div>
  );
};

export default HeroSection;
